<template>
  <div id="app" class="container">
    <Editor/>
  </div>
</template>

<script>
import Editor from './components/Editor.vue'

export default {
  name: 'app',
  components: {
    Editor
  }
}
</script>

<style>
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .main {
    height: 80vh;
    display: flex;
    flex-direction: column;
  }
</style>
